const BaseCategoryPage = require('base/category-page');
// const Server = require('helper/server');
const { advancedSearch } = require('helper/search');

const searchlTpl = Handlebars.templates['templates/search-tpl'];
const advancedSearchlTpl = Handlebars.templates['templates/advanced-search-tpl'];
class Category extends BaseCategoryPage {
  search () {
    const { showContent, code } = this.selectedTreeNode;
    const { articleId, PID } = this.query.params;
    this.$content.find('.block__content').spin(); // 搜索前先旋转
    // 后台详情预览、展示详情、文章列表、采购公告列表
    if (showContent && this.previewFlag) {
      this.renderPreview({ categoryCode: code, articleId, PID });
    } else if (showContent) {
      this.renderDetail({ code });
    } else {
      let payload = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        code,
        isAll: false
      };
      $.extend(payload, this.query.params);
      this.client
        .searchArticleByKeyWord(payload)
        .done((...res) => this.renderList(...res));
    }
  }

  initSearchPanel () {
    const { showContent = false } = this.selectedTreeNode;
    let { code } = this.treeData();
    if (showContent) {
      this.$searchPanel.html('');
    } else if (code == 'ZcyAnnouncement') { // 采购公告有高级搜素功能
      this.$searchPanel.html(advancedSearchlTpl);
    } else {
      this.$searchPanel.html(searchlTpl);
    }
  }

  /**
   * 公告高级搜索
   */
  async advancedSearch () {
    advancedSearch.apply(this);
  }
}

module.exports = Category;
